import * as React from "react";

function SvgCreateTemplate(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={17.58} height={23.328} {...props}>
        <path
          d="M12.315 0H1.892A1.855 1.855 0 000 1.811v19.707a1.854 1.854 0 001.892 1.81h13.8a1.854 1.854 0 001.888-1.81V5.882L12.315 0zM1.892 21.554a.146.146 0 01-.118-.045V1.822a.151.151 0 01.118-.048h8.167v4.143a1.607 1.607 0 001.606 1.6h4.143v13.992a.16.16 0 01-.118.045zm9.94-15.806V2.122l3.245 3.626zM9.506 8.675H3.758a.832.832 0 00-.831.831.832.832 0 00.831.831h5.748a.832.832 0 00.831-.831.832.832 0 00-.831-.831zm4.322 4.314H3.758a.832.832 0 00-.831.831.832.832 0 00.831.831h10.07a.832.832 0 00.831-.831.832.832 0 00-.831-.831zM9.506 17.3H3.758a.832.832 0 00-.831.831.832.832 0 00.831.831h5.748a.832.832 0 00.831-.831.832.832 0 00-.831-.831z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgCreateTemplate;
